import { render, staticRenderFns } from "./ClearAllNotificationsButton.vue?vue&type=template&id=23559beb&scoped=true&"
import script from "./ClearAllNotificationsButton.vue?vue&type=script&lang=js&"
export * from "./ClearAllNotificationsButton.vue?vue&type=script&lang=js&"
import style0 from "./ClearAllNotificationsButton.vue?vue&type=style&index=0&id=23559beb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23559beb",
  null
  
)

export default component.exports